import request from '@/utils/request'
import {
  Config
} from './config'
import {
  param
} from '@/utils'

const BASE_URL = Config.restUrl
const CLIENTID = Config.clientId
const CLIENTSECRET = Config.clientSecret

export function getTokenStr() {
  return request({
    url: `${BASE_URL}oauth/access_token?client_id=${CLIENTID}&client_secret=${CLIENTSECRET}`,
    method: 'post'
  })
}

export function login(userNo, password) {
  return request({
    url: `${BASE_URL}core_organization/users/check?account=${userNo}&password=${password}`,
    method: 'get'
  })
}

export function getUserInfo(userID) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/login/${userID}`,
    method: 'get'
  })
}

export function getUserRoleMenus(accountId) {
  return request({
    url: `${BASE_URL}business_catering/hb_roles/role_menu/account/${accountId}`,
    method: 'get'
  })
}

export function loginbak(data) {
  return request({
    url: '/vue-element-admin/user/login',
    method: 'post',
    data
  })
}

export function getInfo(userID) {
  return request({
    url: `${BASE_URL}business_catering/users/${userID}`,
    method: 'get'
  })
}

export function getInfobak(token) {
  return request({
    url: '/vue-element-admin/user/info',
    method: 'get',
    params: {
      token
    }
  })
}

export function logout() {
  return request({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  })
}

export function getUserSubIdentities(user_id) {
  return request({
    url: `${BASE_URL}core_organization/user_sub_identities?user_id=${user_id}`,
    method: 'get'
  })
}

export function getAccountList(keywords, accountType) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/get_list?keywords=${keywords}&accountType=${accountType}`,
    method: 'get'
  })
}

export function addAccount(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts`,
    method: 'post',
    data: params
  })
}

export function updateAccount(id, params) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/${id}`,
    method: 'put',
    data: params
  })
}

export function deleteAccount(id) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/${id}`,
    method: 'delete'
  })
}

export function getUserInfoByNumber(number) {
  return request({
    url: `${BASE_URL}core_organization/users/get_by_number/${number}`,
    method: 'get'
  })
}

export function getUserInfoById(id) {
  return request({
    url: `${BASE_URL}core_organization/users/${id}`,
    method: 'get'
  })
}

export function saveAccountRole(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/account_role`,
    method: 'post',
    data: params
  })
}

export function saveAccountAuth(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/save_author`,
    method: 'put',
    data: params
  })
}

export function saveAccountRooms(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/save_rooms`,
    method: 'put',
    data: params
  })
}

export function changeAccountOnlineStatus(id, status, hotelId) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/online_change/${id}/${status}?hotelId=${hotelId}`,
    method: 'post'
  })
}

export function getTemporaryAccountList() {
  return request({
    url: ``,
    method: 'get'
  })
}

export function addTemporaryAccount(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/temporary`,
    method: 'post',
    data: params
  })
}

export function changeAccountOnlineStatusBak(acountId, status) {
  return request({
    url: `${BASE_URL}business_catering/hb_accounts/online_change/${acountId}?online=${status}`,
    method: 'post'
  })
}
